export const wishListInputRules = (value) => {
  const stringValue = value?.trim() ?? '';

  if (stringValue === '') {
    return 'List name is required';
  }
  if (/[^a-zA-Z0-9 -]/.test(stringValue)) {
    return 'Remove all special characters';
  }
  if (stringValue.length < 3) {
    return 'Enter at least 3 characters';
  }
  return '';
};

const LETTERS_NUMBERS_RULE = /^[A-Za-z][A-Za-z0-9]*$/;

const getNameValidationErrorType = (value) => {
  const inputValue = (value || '').trim();
  if (!inputValue) {
    return 'required';
  }
  if (inputValue.length < 2) {
    return 'length';
  }
  if (!LETTERS_NUMBERS_RULE.test(inputValue)) {
    return 'pattern';
  }
  return null;
};

export const validateNameFieldError = (value, label, showRequired) => {
  const errorType = getNameValidationErrorType(value);

  switch (errorType) {
    case 'required':
      return showRequired ? `Enter your ${label}` : '';
    case 'length':
      return 'Enter at least 2 characters';
    case 'pattern':
      return 'Remove all special characters';
    default:
      return '';
  }
};

export const isValidName = (value) => !getNameValidationErrorType(value);

export default {
  wishListInputRules,
  validateNameFieldError,
  isValidName,
};
